import React from "react";

const UserIcon: React.FC<{ className?: string; size?: number }> = ({ className = "", size = 40 }) => {
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="20" cy="20" r="19.4444" fill="white" stroke="#EDEBEC" strokeWidth="1.11111" />
            <path
                d="M21.5 23.5L15.5 24L13 25.5C13 26.3333 13.1 28.1 13.5 28.5C13.9 28.9 17.3333 29.3333 19 29.5L25.5 28.5L27 26.5L26 24.5L21.5 23.5Z"
                fill="#BBD8ED"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9849 23.3438C16.1173 23.3438 12.8145 23.9285 12.8145 26.2704C12.8145 28.6123 16.0964 29.218 19.9849 29.218C23.8525 29.218 27.1545 28.6323 27.1545 26.2914C27.1545 23.9504 23.8735 23.3438 19.9849 23.3438Z"
                stroke="#00A7E4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9849 20.0039C22.523 20.0039 24.5802 17.9458 24.5802 15.4077C24.5802 12.8696 22.523 10.8125 19.9849 10.8125C17.4468 10.8125 15.3887 12.8696 15.3887 15.4077C15.3802 17.9373 17.424 19.9954 19.9526 20.0039H19.9849Z"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default UserIcon;